import { ACCOUNT_TYPE } from "../utils/constants";
export const sidebarLinks = [
  {
    id: 1,
    name: "Profile",
    path: "/dashboard/profile",
    icon: "VscAccount",
  },
  {
    id: 2,
    name: "Teaching Analytics",
    path: "/dashboard/teaching-analytics",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscGraph",
  },
  {
    id: 3,
    name: "My Courses",
    path: "/dashboard/my-courses",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscVm",
  },
  {
    id: 4,
    name: "New Course",
    path: "/dashboard/new-course",
    type: ACCOUNT_TYPE.INSTRUCTOR,
    icon: "VscAdd",
  },
  {
    id: 5,
    name: "Enrolled Courses",
    path: "/dashboard/enrolled-courses",
    type: ACCOUNT_TYPE.STUDENT,
    icon: "VscBook",
  },
  {
    id: 6,
    name: "Wishlist",
    path: '/dashboard/wishlist',
    type: ACCOUNT_TYPE.STUDENT,
    icon: 'VscInbox',
  },
];
